import React from "react";
import { Box } from "@mui/material";

const STYLES = `
  .sq-loader {
    width: var(--sq-size, 72px);
    height: var(--sq-size, 72px);
    position: relative;
    transform: rotate(45deg);
  }
  .sq-loader::after {
    content: "";
    position: absolute;
    inset: -12px;
    border-radius: 18px;
    background: radial-gradient(circle, rgba(217,247,82,.25), transparent 60%);
    animation: sq-glow 1.6s ease-in-out infinite;
  }
  .sq-block {
    position: absolute;
    width: 50%;
    height: 50%;
    border-radius: 10px;
    animation-duration: 1.6s;
    animation-iteration-count: infinite;
    animation-timing-function: cubic-bezier(.65, 0, .35, 1);
  }
  .sq-b1 { background: #133231; top: 0; left: 0; animation-name: sq-move1; }
  .sq-b2 { background: #346B4E; top: 0; right: 0; animation-name: sq-move2; }
  .sq-b3 { background: #D9F752; bottom: 0; left: 0; animation-name: sq-move3; }
  .sq-b4 { background: #133231; bottom: 0; right: 0; animation-name: sq-move4; opacity: .15; }

  @keyframes sq-move1 {
    0%   { transform: translate(-140%, -140%) scale(.6); }
    40%  { transform: translate(0, 0) scale(1); }
    55%  { transform: scale(1.05); }
    70%  { transform: scale(1); }
    100% { transform: translate(-140%, -140%) scale(.6); }
  }
  @keyframes sq-move2 {
    0%   { transform: translate(140%, -140%) scale(.6); }
    45%  { transform: translate(0, 0) scale(1); }
    60%  { transform: scale(1.05); }
    75%  { transform: scale(1); }
    100% { transform: translate(140%, -140%) scale(.6); }
  }
  @keyframes sq-move3 {
    0%   { transform: translate(-140%, 140%) scale(.6); }
    50%  { transform: translate(0, 0) scale(1); }
    65%  { transform: scale(1.05); }
    80%  { transform: scale(1); }
    100% { transform: translate(-140%, 140%) scale(.6); }
  }
  @keyframes sq-move4 {
    0%   { transform: scale(.8); opacity: .05; }
    50%  { transform: scale(1);  opacity: .15; }
    100% { transform: scale(.8); opacity: .05; }
  }
  @keyframes sq-glow {
    0%   { opacity: .2; transform: scale(.9); }
    50%  { opacity: .5; transform: scale(1);  }
    100% { opacity: .2; transform: scale(.9); }
  }
  @media (prefers-reduced-motion: reduce) {
    .sq-block, .sq-loader::after { animation: none; transform: none; }
  }
`;

let stylesInjected = false;

// minHeight (with centered) reserves an area and centres the loader in it, instead of letting it
// sit at the end of the content flow — where on a phone it lands under the bottom navigation.
const SquarehubLoader = ({ size = 72, centered = false, minHeight }) => {
  if (!stylesInjected && typeof document !== "undefined") {
    const el = document.createElement("style");
    el.setAttribute("data-sq-loader", "1");
    el.textContent = STYLES;
    document.head.appendChild(el);
    stylesInjected = true;
  }

  const loader = (
    <div
      className="sq-loader"
      role="status"
      aria-label="Loading"
      style={{ "--sq-size": `${size}px` }}
    >
      <div className="sq-block sq-b1" />
      <div className="sq-block sq-b2" />
      <div className="sq-block sq-b3" />
      <div className="sq-block sq-b4" />
    </div>
  );

  if (!centered) return loader;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight,
        py: minHeight ? 0 : `${size}px`,
      }}
    >
      {loader}
    </Box>
  );
};

export default SquarehubLoader;
